import React from 'react';
import { Workplace } from '../../../../graphql/graphql';
import styles from './ORSMSettingsWorkplaceSelection.module.scss';
import ORSMSettingsWorkplaceSelectionItem from './ORSMSettingsWorkplaceSelectionItem';

interface Props {
	workplaces: Workplace[];
	onSelect: (workplace: Workplace) => void;
}

const ORSMSettingsWorkplaceSelection: React.FC<Props> = ({
	workplaces,
	onSelect,
}) => {
	return (
		<div className={styles.wrapper}>
			{workplaces.map(item => (
				<ORSMSettingsWorkplaceSelectionItem
					item={item as Workplace}
					onSelect={onSelect}
				/>
			))}
		</div>
	);
};

export default ORSMSettingsWorkplaceSelection;
